import { createGlobalStyle } from 'styled-components';

import { Media } from '@/js/libs/ui';
import { modalGlobalStyles } from '@/js/libs/ui/src/V2';

export const GlobalStyles = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    font-family: CircularXXWeb, sans-serif;
    font-feature-settings: 'ss08' on;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  }

  body {
    overscroll-behavior: none;
    font-weight: normal;
    font-size: 14px;

    /* stylelint-disable number-max-precision */
    line-height: 1.42857;
    /* stylelint-enable number-max-precision */

    color: ${({ theme }) => theme.colors.black_1};
    background-color: ${({ theme }) => theme.colors.grey00_6};
    transition: opacity .2s;

    /* Safari desktop only - fixed pseudo element border top */
    @media ${Media.smMin} {
      @supports (-webkit-hyphens: none) and (not (overflow: -webkit-marquee)) and (not (-ms-ime-align: auto)) {
        &::before {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background-color: ${({ theme }) => theme.colors.grey10_1};
          z-index: 9999;
          pointer-events: none;
        }
      }
    }
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  [hidden],
  template {
    display: none;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: 500;
  }

  dfn {
    font-style: italic;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  mark {
    background: #ff0;
    color: ${({ theme }) => theme.colors.black_1};
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sup {
    top: -0.5em;
  }

  sub {
    bottom: -0.25em;
  }

  img {
    border: 0;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  figure {
    margin: 1em 40px;
  }

  hr {
    box-sizing: content-box;
    height: 0;
  }

  pre {
    overflow: auto;
  }

  code,
  kbd,
  pre,
  samp {
    font-family: monospace;
    font-size: 1em;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
  html input[type='button'],
  input[type='reset'],
  input[type='submit'] {
    appearance: button;
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: default;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  input {
    line-height: normal;
  }

  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  input[type='search'] {
    appearance: textfield;
    box-sizing: content-box;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration {
    appearance: none;
  }

  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  legend {
    border: 0;
    padding: 0;
  }

  textarea {
    overflow: auto;
  }

  optgroup {
    font-weight: 500;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
  }

  p {
    margin: 0 0 10px;
  }

  ul,
  ol {
    margin-top: 0;
    margin-bottom: 10px;

    ul,
    ol {
      margin-bottom: 0;
    }
  }

  input,
  button,
  select,
  textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  code {
    background: ${({ theme }) => theme.colors.grey01_1};
    padding: 9px 15px;
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.colors.grey30_1};
    font-weight: normal;
    color: ${({ theme }) => theme.colors.black_1};
    display: inline-block;
    font-size: 13px;
  }

  a {
    background-color: transparent;
    outline: 0;
    color: ${({ theme }) => theme.colors.link100};

    &:hover {
      color: ${({ theme }) => theme.colors.link120};
    }

    &, &:hover,&:focus,&:visited {
      text-decoration: none;
    }
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.grey05_1};

    &:not(.loaded) {
      justify-content: center;
    }

    /* stylelint-disable selector-class-pattern */
    .ReactSelect {
      &__single-value {
        color: ${({ theme }) => theme.colors.black_1}
      }

      &__control {
        background-color: ${({ theme }) => theme.colors.grey00_1};
        border-color: ${({ theme }) => theme.colors.grey30_1};

        &:hover {
          border-color: ${({ theme }) => theme.colors.grey70_1};
        }

        &--is-focused {
          &, &:hover {
            border: 1px solid ${({ theme }) => theme.colors.main};
            box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.main};
          }
        }

        &--is-disabled {
          background-color: ${({ theme }) => theme.colors.grey01_1};
        }
      }

      &__option {
        word-break: break-word;
      }

      &__placeholder {
        max-width: calc(100% - 16px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &__dropdown-indicator svg {
        fill: ${({ theme }) => theme.colors.main};
      }

      &__indicator-separator {
        display: none;
      }
    }
    /* stylelint-enable selector-class-pattern */
  }

  ${modalGlobalStyles}

  /* styled-bootstrap-grid Container responsive padding override */
  [data-name="container"], [data-name^="col-"] {
    @media ${Media.smMax} {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  [data-name="row"] {
    @media ${Media.smMax} {
      margin-left: -8px;
      margin-right: -8px;
    }
  }

  /* rc-slider tooltip styles */
  .rc-slider-tooltip {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: visible;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  }

  .rc-slider-tooltip * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  }

  .rc-slider-tooltip-hidden {
    display: none;
  }

  .rc-slider-tooltip-placement-top {
    padding: 4px 0 8px;
  }

  .rc-slider-tooltip-inner {
    padding: 6px 5px;
    min-width: 30px;
    height: 24px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    text-align: center;
    text-decoration: none;
    background-color: #1bab5d;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }

  .rc-slider-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }

  .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
    bottom: 4px;
    left: 50%;
    margin-left: -4px;
    border-width: 4px 4px 0;
    border-top-color: #1bab5d;
  }

  /* https://github.com/Hacker0x01/react-datepicker/issues/3924 */
  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }
`;
